import FastEvent from '../../../shared/classes/fastEvent';
import TPlayer from '../templates/player';
import { useAppSelector } from '../../../shared/store/hooks';
import { routerSelector } from '../../../shared/store/slices/router.slice';

function Player() {
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);

  return (
    <>
      <TPlayer asset={currentParams?.content as FastEvent} />
    </>
  );
}

export default Player;
